import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { IMAGES, GATEWAY, CONTACT } from "../content";

const Panel = ({ data, img, testid, onClick, delay }) => (
  <motion.button
    initial={{ opacity: 0, y: 40 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    data-testid={testid}
    onClick={onClick}
    className="group relative flex-1 md:hover:flex-[1.5] transition-[flex-grow] duration-700 ease-out overflow-hidden text-left min-h-[42vh] md:min-h-0 cursor-pointer"
  >
    <img
      src={img}
      alt=""
      className="absolute inset-0 w-full h-full object-cover opacity-30 saturate-[0.6] transition-[opacity,transform,filter] duration-700 group-hover:opacity-55 group-hover:scale-105 group-hover:saturate-100"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#E9EDF3] via-[#E9EDF3]/55 to-[#E9EDF3]/25" />
    <div className="relative h-full flex flex-col justify-end p-8 sm:p-12">
      <div className="font-mono-tech text-xs uppercase tracking-[0.3em] text-emerald">{data.kicker}</div>
      <h2 className="mt-2 font-display font-extrabold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#0B0D10] flex items-center gap-4">
        {data.title}
        <span className="w-11 h-11 shrink-0 rounded-full border border-[#0B0D10]/25 flex items-center justify-center text-[#0B0D10] transition-colors duration-500 group-hover:bg-emerald group-hover:border-emerald group-hover:text-white">
          <ArrowUpRight size={20} strokeWidth={2.5} />
        </span>
      </h2>
      <p className="mt-3 text-base text-neutral-700 max-w-md">{data.desc}</p>
    </div>
  </motion.button>
);

const Gateway = ({ lang, setLang }) => {
  const navigate = useNavigate();
  const t = GATEWAY[lang];

  return (
    <div data-testid="gateway-section" className="relative min-h-screen flex flex-col bg-[#E9EDF3]">
      <header className="absolute top-0 inset-x-0 z-20 flex items-center justify-between px-5 sm:px-8 h-[72px]">
        <img src="/milsis-logo.png" alt="MILSIS" className="h-9 w-auto" />
        <div className="flex items-center border border-[#CBD3DF] bg-white/80 backdrop-blur rounded-sm overflow-hidden" data-testid="gateway-lang-toggle">
          {["tr", "en"].map((l) => (
            <button
              key={l}
              data-testid={`gateway-lang-toggle-${l}`}
              onClick={() => setLang(l)}
              className={`px-3 py-1.5 font-mono-tech text-xs uppercase tracking-widest transition-colors duration-300 ${
                lang === l ? "bg-emerald text-white font-semibold" : "text-neutral-600 hover:text-[#0B0D10]"
              }`}
            >
              {l}
            </button>
          ))}
        </div>
      </header>

      <div className="flex-1 flex flex-col md:flex-row pt-[72px]">
        <Panel
          data={t.engineering}
          img={IMAGES.hardware}
          testid="gateway-link-engineering"
          onClick={() => navigate("/muhendislik")}
          delay={0.25}
        />
        <div className="h-px md:h-auto md:w-px bg-[#CBD3DF] shrink-0" />
        <Panel
          data={t.spare}
          img={IMAGES.spareparts}
          testid="gateway-link-spare-parts"
          onClick={() => { window.location.href = "https://www.partspare.net"; }}
          delay={0.4}
        />
      </div>

      <footer className="relative z-10 border-t border-[#CBD3DF] px-5 sm:px-8 py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
        <span className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-neutral-600">{t.brand}</span>
        <span className="font-mono-tech text-[11px] text-neutral-500">{CONTACT.legal}</span>
      </footer>
    </div>
  );
};

export default Gateway;
